import React from 'react';
import {
    View,
    Text,
    TouchableOpacity,
    TextInput,
    Alert,
    FlatList,
    Image,
    ScrollView,
    ActivityIndicator, RefreshControl
} from 'react-native';
import { connect } from 'react-redux';
import IAppState from "../Models/App/IAppState";

import {AnyAction} from "redux";


import {StackNavigationProp} from "@react-navigation/stack";
import { RouteProp } from '@react-navigation/native';
import AppText from "../Components/AppText";
import HideableView from "../Components/HideableView";
import {DrawerNavigationProp} from "@react-navigation/drawer";
import ClientItem from "../Components/ClientItem";
import CourierItem from "../Components/CourierItem";
import IUser from "../Models/User/IUser";
import HttpRequest from "../utils/HttpRequest";
import IOrder from "../Models/IOrder";
import OpenedOrderItem from "../Components/OpenedOrderItem";
import {saveOpenedOrders} from "../Models/Courier/CourierActions";
import ConfirmionModal from "../Components/ConfirmionModal";

type navProps = DrawerNavigationProp< any, 'Clients'>;
interface IProps {
    navigation:navProps;
    user?:IUser
    saveOpenedOrders:(orders:IOrder[])=>AnyAction
    openedOrders:IOrder[]
}
interface IState {
    isAddOpened:boolean;
    orders:IOrder[];
    fetching:boolean;
    confirmText:string;
    showConfirm:boolean;
    orderToRemove?:IOrder
}

class Orders extends React.Component<IProps> {

    state:IState={
        isAddOpened:false,
        orders:[],
        fetching:false,
        confirmText:'',
        showConfirm:false
    }
    componentDidMount() {
        if(this.props.user ){
            this.fetchData(this.props.user.CourierId)
        }
    }
    refresh(){
        if(this.props.user ){
            this.fetchData(this.props.user.CourierId)
        }
    }
    fetchData(courierId?:number){
        this.setState({fetching:true})
        HttpRequest('couriers/orders?id='+courierId,'GET').then((result)=>{
            this.props.saveOpenedOrders(result.data)
        }).catch(e=>{

        }).finally(()=>this.setState({fetching:false}))
    }
    removeOrder(){
        let orderToRemove=this.state.orderToRemove;
        this.setState({showConfirm:false})
        if(orderToRemove && orderToRemove.id){
            let orderId=orderToRemove.id;
            let orders=this.props.openedOrders;
            orders=orders.filter((o)=>o.id!=orderId)
            this.props.saveOpenedOrders(orders)
            HttpRequest('orders','DELETE',{id:orderId}).then((result)=>{

            }).catch(e=>{

            })
        }
    }
    selectOrderToRemove(order:IOrder){
        let text='האם את רוצה למחוק את ההזמנה של '+order.Client?.businessName+ "?";
        this.setState({orderToRemove:order,showConfirm:true,confirmText:text})
    }
    removeSubOrder(orderId:number,subOrderId:number){
        let orders=this.props.openedOrders;
        for(let i=0;i<orders.length;i++){
            if(orders[i].id==orderId){
                let subOrders=orders[i].SubOrders;
                subOrders=subOrders.filter((s)=>s.id!=subOrderId);
                orders[i].SubOrders=subOrders;

            }
        }
    }
    render() {
        const data:any[]=[
            {name:'מוהנד עבד אלהדי',area:'צפון',phone:'052-1234567',licenseType:'B'}
        ]
        return(
           <ScrollView refreshControl={<RefreshControl refreshing={this.state.fetching} onRefresh={()=>this.refresh()} />}  style={{display:'flex',flexDirection:'column',backgroundColor:'white',flex:1,width:'100%',paddingTop:0}}>

                <FlatList
                    data={this.props.openedOrders}
                    ListHeaderComponent={()=><View style={{height:30,width:'100%',backgroundColor:'#373737',paddingLeft:15,paddingRight:15,flexDirection:'row',alignItems:'center'}}>
                        <View style={{flex:0.23,alignItems:'flex-start'}}>
                            <AppText style={{color:'white'}}>שם המזמין</AppText>
                        </View>
                        <View style={{flex:0.34,alignItems:'flex-start'}}>
                            <AppText style={{color:'white'}}>כתובת</AppText>
                        </View>
                        <View style={{flex:0.23,alignItems:'flex-start'}}>
                            <AppText style={{color:'white'}}>טלפון</AppText>
                        </View>
                        <View style={{flex:0.2,alignItems:'flex-start'}}>

                        </View>
                    </View>}
                    renderItem={({ item }) =><OpenedOrderItem order={item} removeSubOrderCallBack={(orderId:number,subOrderId:number)=>this.removeSubOrder(orderId,subOrderId)} onLongPress={(item:IOrder)=>this.selectOrderToRemove(item)}/> }
                />
                <ConfirmionModal confirmCallBack={()=>this.removeOrder()} closeCallBack={()=>this.setState({showConfirm:false})} text={this.state.confirmText} show={this.state.showConfirm}/>

            </ScrollView>
        );
    }
}
const mapStateToProps = (state:IAppState) => {
    //Alert.alert(JSON.stringify(state))
    return {
        user:state.user.current,
        openedOrders:state.courier.openedOrders
    };
};

const mapDispatchToProps ={
    saveOpenedOrders:saveOpenedOrders

};

export default connect(mapStateToProps, mapDispatchToProps)(Orders);
